<template>
  <v-card class="pa-8">
    <div class="header">
      <div
        class="d-flex align-center"
        style="gap: 10px; margin-bottom: 10px;"
      >
        <v-icon
          size="24"
          color="#FF4C51"
        >
          {{ icons.mdiCancel }}
        </v-icon>
        <h3 class="title">
          Cancelar Solicitação
        </h3>
      </div>
      <span style="font-size: 14px; font-weight: 500; color: #E7E3FC;">Descreva o motivo do cancelamento</span>
      <v-btn
        icon
        class="close-btn"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="content pt-7">
      <div
        class="d-flex flex-column"
        style="gap: 16px;"
      >
        <InfoPainel
          :icon="icons.mdiAlertCircleOutline"
          text="Esta ação é irreversível. Após o cancelamento, não será possível editar ou reativar esta solicitação."
          text-color="#FF4C51"
          icon-color="#FF4C51"
          border-color="#5E3132"
          background-color="#FF4C510D"
        />

        <div
          class="d-flex flex-column"
          style="gap: 20px; margin-top: 10px;"
        >
          <span style="font-size: 14px; font-weight: 500; color: #E7E3FC;">
            Descrição do motivo
          </span>
          <v-textarea
            v-model="cancelReason"
            label="Descrição"
            placeholder="Descreva o motivo do cancelamento desta solicitação"
            outlined
            rows="4"
            :rules="[rules.required]"
          />
        </div>

        <div
          class="d-flex justify-end"
          style="gap: 10px; margin-top: 10px;"
        >
          <v-btn
            outlined
            color="white"
            @click="closeModal"
          >
            <span>Voltar</span>
          </v-btn>
          <v-btn
            color="error"
            :disabled="!cancelReason || isCancelling"
            @click="handleCancel"
          >
            <template v-if="!isCancelling">
              <v-icon class="mr-2">
                {{ icons.mdiCancel }}
              </v-icon>
              <span>Cancelar</span>
            </template>
            <v-progress-circular
              v-else
              indeterminate
              color="white"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import InfoPainel from '@/components/InfoPainel.vue'
import axiosIns from '@/plugins/axios'
import {
  mdiAlertCircleOutline,
  mdiCancel,
  mdiClose,
} from '@mdi/js'

export default {
  name: 'CancelSolicitationModal',
  components: {
    InfoPainel,
  },
  props: {
    solicData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiCancel,
        mdiAlertCircleOutline,
      },
      cancelReason: '',
      isCancelling: false,
      rules: {
        required: value => !!value || 'Campo obrigatório',
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async handleCancel() {
      if (!this.cancelReason) {
        return
      }

      try {
        this.isCancelling = true

        // Aqui você implementará a lógica de cancelamento
        // Exemplo:
        const body = {
          status: 'cancelled',
          cancellation_reason: this.cancelReason,
        }
        await axiosIns.put(`/api/v1/solicitations/transport_solicitation_trip/update/${this.solicData.id}`, body)

        this.$swal({
          title: 'Sucesso!',
          text: 'Solicitação cancelada com sucesso.',
          icon: 'success',
          confirmButtonText: 'Ok',
        })

        this.$emit('cancel-success')
      } catch (error) {
        console.error('Erro ao cancelar solicitação:', error)
        this.$swal({
          title: 'Erro!',
          text: 'Não foi possível cancelar a solicitação. Tente novamente.',
          icon: 'error',
          confirmButtonText: 'Ok',
        })
      } finally {
        this.isCancelling = false
      }
    },
  },
}
</script>

<style scoped>
.header {
  width: 100%;
  margin-top: -2px;
  text-align: left;
}

.title {
  font-weight: 600;
  font-size: 18px;
  color: #E7E3FC;
}

.close-btn {
  position: absolute;
  right: 20px;
  top: 15px;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
